module.exports = __webpack_public_path__ + "static/img/LustrousOcean.a3a5c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sp/LustrousOcean.png
// module id = RpKM
// module chunks = 1